import { Components, Theme } from '@mui/material/styles';

export const MuiIconButton: Components<Theme>['MuiIconButton'] = {
  styleOverrides: {
    root: {
      padding: '4px',
      zIndex: 4,
      '&:hover': {
        backgroundColor: 'color-mix(in srgb, var(--palette-action-hover) 10%, transparent)',
      },
      '& > svg': {
        width: '100%',
        height: '100%',
      },
    },
    sizeSmall: {
      width: 24,
      height: 24,
    },
    sizeMedium: {
      width: 30,
      height: 30,
    },
    sizeLarge: {
      width: 36,
      height: 36,
    },
  },
};
